import {localFind} from "../utils/api";

export const GET_LESSONS = 'GET_LESSONS';
export const GET_LESSONS_SUCCESS = 'GET_LESSONS_SUCCESS';
export const GET_LESSONS_FAILED = 'GET_LESSONS_FAILED';
export const getLessons = localFind('v1/lesson/find', GET_LESSONS, GET_LESSONS_SUCCESS, GET_LESSONS_FAILED);
